// extracted by mini-css-extract-plugin
export default {"tile":"tile___mOjIa","tileTitle":"tileTitle___x4FD1","tileLength":"tileLength___AgTBC","score":"score___f8Jpw","scoreInfo":"scoreInfo___gaxft"};